import Home from "pages/Home/Home";
import { CotizadorRoutes } from "./QuoterStepsRoutes";
import { PrivateGuard } from "guards/PrivateGuard";
import { MyFavoritePlanRoutes } from "./MyFavoritePlanRoutes";
import QuoterLayout from "layouts/QuoterLayout";

export const QuoterRoutes = [
    {
        element: <PrivateGuard />,
        children: [
            { path: "/home", element: <Home /> },
            { path: "/home/:userdata", element: <Home /> },
            {
                element: <QuoterLayout />,
                children: [
                    ...CotizadorRoutes,
                    ...MyFavoritePlanRoutes
                ]
            }
        ],
    },
]
